import React from 'react';
import { Box, Skeleton, Stack, Tooltip, Typography } from '@mui/material';
import useIbkrBrokerLiveState from 'hooks/useIbkrBrokerLiveState';

export default function BrokerConnectionStatus() {
  const { connection, loading } = useIbkrBrokerLiveState();
  const connected = Boolean(connection?.connected && !connection?.auth_expired);
  const degraded = Boolean(connection?.degraded || connection?.stale);
  const color = connected && !degraded ? '#37b26b' : degraded ? '#e5a51b' : '#e65353';
  const label = connected && !degraded ? 'Broker connected' : degraded ? 'Broker connection degraded' : 'Broker disconnected';
  const detail = connection?.account_ids?.length ? `${label} · ${connection.account_ids.join(', ')}` : label;

  if (loading && connection?.connection_state === 'unavailable') {
    return <Skeleton variant="rounded" width={126} height={22} />;
  }

  return (
    <Tooltip title={detail}>
      <Stack direction="row" alignItems="center" spacing={1} aria-label={label}>
        <Box sx={{ width: 8, height: 8, bgcolor: color, borderRadius: '50%', boxShadow: `0 0 0 4px ${color}24` }} />
        <Typography sx={{ fontSize: 13, color: 'var(--app-text-secondary, #67748E)', whiteSpace: 'nowrap' }}>{label}</Typography>
      </Stack>
    </Tooltip>
  );
}
